module.exports = __webpack_public_path__ + "static/media/caret-top.0e7c63b5.svg";